import { Button } from '@mui/material';
import { PANEL_MODES } from './state/reducer';
import React from 'react';
import ThinkingIndicator from './components/ChatThread/components/ThinkingIndicator';
import { translate } from '/b2b/common/helpers/i18n';
import useAIAssistant from './useAIAssistant';

/*
 * Floating entry point for the AI Assistant: a circular button around the Osano
 * mark that expands on hover/focus to reveal the product name and opens the
 * assistant to the last-used view mode. The pill shape, purple glow, and expand
 * animation are owned by the host FAB styles; the accessible name stays present
 * in both states so keyboard and screen-reader users are unaffected.
 */
const AIAssistantLauncher = () => {
    const { panelMode, openAssistant, setPanelMode } = useAIAssistant();
    const isOpen = panelMode === PANEL_MODES.SIDEBAR || panelMode === PANEL_MODES.WIDGET;

    const handleToggle = () => (isOpen ? setPanelMode(PANEL_MODES.COLLAPSED) : openAssistant());

    const label = translate('aiAssistant.name');

    return (
        <Button
            variant="outlined"
            color="tertiary"
            onClick={handleToggle}
            aria-pressed={isOpen}
            aria-label={label}
        >
            <ThinkingIndicator size={20} />
            <span className="aiLauncherLabel">{label}</span>
        </Button>
    );
};

export default AIAssistantLauncher;
